module.exports = __webpack_public_path__ + "assets/4b9efeb61d50ffc789499daa888c9ee6.mp3";